import React, { Fragment } from "react";
import { inject, observer } from "mobx-react";
import { Card, Button, TextField, Grid, Typography, Avatar, IconButton, Switch, Tooltip, Dialog, DialogContent, DialogTitle, DialogActions } from "@material-ui/core";
import { ProfileType } from "../../types/enum";
import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import GridListTileBar from "@material-ui/core/GridListTileBar";
import { withRouter } from "react-router-dom";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";

import LinearProgress from "@material-ui/core/LinearProgress";
import CircularProgress from "@material-ui/core/CircularProgress";

import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";

import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@material-ui/icons/RadioButtonChecked";
import VisibilityIcon from "@material-ui/icons/Visibility";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import CloseIcon from "@material-ui/icons/Close";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import FormControl from "@material-ui/core/FormControl";

import { Storage } from "aws-amplify";
import agent from "../../agent";
import uniqid from "uniqid";

import PlayedAtTable from "./playedAt/PlayedAtTable";
import PlayedWithTable from "./playedWith/PlayedWithTable";
import TradingHourTable from "./tradingHour/TradingHourTable";
import validation from "../../helper/validation"

import DoneIcon from "@material-ui/icons/Done";

import Dropzone from "react-dropzone";
import Loading from "../loadingSpinner/Loading";

import { withStyles } from "@material-ui/core/styles";

import SectionHeader from "../common/SectionHeader";

import "./Design.css";
import { Label } from "react-bootstrap";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const IS_MOBILE = process.env.REACT_APP_IS_MOBILE === "true";

const FILE_MAXSIZE = IS_MOBILE ? 8497152 : 5497152;
const GALLERY_FILE_MAXSIZE = 10485760; // 10MB for gallery images
const ACCEPTED_FILE = "image/*";

// Video provider detection regexes - permissive patterns for standard video URLs
const youtubeReg = /^https?:\/\/(www\.)?(youtube\.com|youtu\.be)/i;
const vimeoReg = /^https?:\/\/(www\.)?(vimeo\.com|player\.vimeo\.com)/i;
const facebookVideoReg = /^https?:\/\/(www\.)?(facebook\.com|fb\.watch)/i;
const tiktokReg = /^https?:\/\/(www\.)?(tiktok\.com|vm\.tiktok\.com)/i;

const styles = theme => ({
    title: {
      color: '#fff',
    }
  });

@inject("designProfileStore", "templateStore", "authStore", "profileStore")
@withRouter
@observer
class Design extends React.Component {
    state = {
        loadingVanityUrlTest: false,
        vanityUrlAvailable: false,
        isLoading: true,
        errorVideo: "",
        errorMusic: "",
        isSubmitted: false,
        newVideoUrl: "",
        newVideoError: "",
        videoUrls: [],
        galleryPreviewOpen: false,
        galleryPreviewImage: null,
        gallerySavedTitles: {},
        galleryDeletingIds: []
    };

    vanityUrlChecker;

    constructor(props) {
        super(props);
        this.props.designProfileStore.reset();
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        
        // set type
        this.setState({errorMusic: "", errorVideo:""})
        this.props.designProfileStore.setType(this.props.templateStore.getType(this.props.type));
        const {currentProfile} = this.props.profileStore
        const profileId = this.props.profileId || currentProfile?.id;
        this.props.designProfileStore
            .loadInitialData(profileId)
            .then(() => {
                // Parse videoUrl string into local videoUrls array
                const videoUrlString = this.props.designProfileStore.videoUrl || "";
                const parsedVideos = this.parseVideoUrlString(videoUrlString);
                this.setState({ videoUrls: parsedVideos });
                // Fetch thumbnails for existing videos in background
                this.fetchThumbnailsForVideos(parsedVideos);
                // Load gallery images from backend
                this.loadGalleryImages(profileId);
            })
            .finally(() => {
                this.setState({ isLoading: false });
            });
    }

    loadGalleryImages = async (profileId) => {
        if (!profileId) return;
        try {
            const response = await agent.GalleryImages.list(profileId);
            if (response?.images) {
                this.props.designProfileStore.setGalleryImages(response.images);
            }
        } catch (error) {
            console.log("Failed to load gallery images:", error);
        }
    };

    fetchThumbnailsForVideos = async (videos) => {
        if (!videos || videos.length === 0) return;
        
        for (let i = 0; i < videos.length; i++) {
            const video = videos[i];
            if (video.provider === "youtube" || video.provider === "vimeo") {
                try {
                    const metadata = await this.fetchVideoMetadata(video.url, video.provider);
                    if (metadata.title || metadata.thumbnail) {
                        this.setState(prevState => {
                            const updatedVideos = [...prevState.videoUrls];
                            if (updatedVideos[i]) {
                                updatedVideos[i] = {
                                    ...updatedVideos[i],
                                    title: metadata.title || updatedVideos[i].title,
                                    thumbnail: metadata.thumbnail || updatedVideos[i].thumbnail
                                };
                            }
                            return { videoUrls: updatedVideos };
                        });
                    }
                } catch (e) {
                    console.log("Could not fetch metadata for video:", video.url, e);
                }
            }
        }
    };

    parseVideoUrlString = (videoUrlString) => {
        if (!videoUrlString || typeof videoUrlString !== 'string') return [];
        // Support both ||| and  |||  delimiters for backward compatibility
        const urls = videoUrlString.includes(" ||| ") 
            ? videoUrlString.split(" ||| ")
            : videoUrlString.split("|||");
        return urls
            .map(url => url.trim())
            .filter(url => url.length > 0)
            .slice(0, 4)
            .map((url, index) => ({
                id: `video-${index}-${Date.now()}`,
                url: url,
                provider: this.detectVideoProvider(url) || "unknown",
                title: "",
                thumbnail: ""
            }));
    };

    serializeVideoUrls = (videoUrlsArray) => {
        if (!videoUrlsArray || !Array.isArray(videoUrlsArray)) return "";
        return videoUrlsArray
            .filter(v => v != null)
            .map(v => (typeof v === 'string' ? v : (v.url || "")))
            .filter(url => url && url.trim().length > 0)
            .slice(0, 4)
            .join(" ||| ");
    };

    

    handleVanityUrlChange = e => {
        let vanityUrl = e.target.value;
        this.props.designProfileStore.setVanityUrl(vanityUrl);
        this.setState(
            {
                ...this.state,
                loadingVanityUrlTest: true,
                vanityUrlAvailable: false
            },
            () => {
                clearTimeout(this.vanityUrlChecker);
                if (this.props.designProfileStore.vanityUrl.length !== 0) {
                    this.vanityUrlChecker = setTimeout(() => {
                        this.props.designProfileStore.checkVanityUrl().then(response => {
                            this.setState({
                                ...this.state,
                                loadingVanityUrlTest: false,
                                vanityUrlAvailable: response
                            });

                            if (!response) {
                                this.props.templateStore.openSnackbar(this.errorText("vanityUrl"));
                                window.scrollTo(0, 0);
                            }
                        });
                    }, 2000);
                } else {
                    this.setState({
                        ...this.state,
                        loadingVanityUrlTest: false,
                        vanityUrlAvailable: false
                    });
                }
            }
        );
    };

    handleVideoUrlChange = e => {
        this.setState({errorVideo: ""})
        this.props.designProfileStore.setVideoUrl(e.target.value)
    }
    handleValidateVideoUrl = e => {
        if(this.props.designProfileStore.videoUrl.length === 0) return this.setState({errorVideo: ""})
        if(!validation.urlValidation(this.props.designProfileStore.videoUrl)) {
            this.setState({errorVideo: "Invalid URL"})
        } else{    
            this.props.designProfileStore.setVideoUrl(validation.linkify(this.props.designProfileStore.videoUrl))
            this.setState({errorVideo: ""})
        }
    }
    handleMusicUrlChange = e => {
        this.setState({errorMusic: ""})
        this.props.designProfileStore.setMusicUrl(e.target.value);
    }
    handleValidateMusicUrl = e => {
        if(this.props.designProfileStore.musicUrl.length === 0) return this.setState({errorMusic: ""})
        if(!validation.urlValidation(this.props.designProfileStore.musicUrl)) {
            this.setState({errorMusic: "Invalid URL"})
        } else{
            this.props.designProfileStore.setMusicUrl(validation.linkify(this.props.designProfileStore.musicUrl))
            this.setState({errorMusic: ""})
        }
    }
    handleSonglistChange = e => this.props.designProfileStore.setSongList(e.target.value);
    handleTestimonialContentChange = index => e => {
        this.props.designProfileStore.setTestimonialContent(index, e.target.value);
        if (e.target.value) {
            this.props.designProfileStore.setError("testimonials[" + index + "].Content", undefined);
        } else {
            this.props.designProfileStore.setError("testimonials[" + index + "].Content", "The Content field is required.");
        }
    };
    handleTestimonialNameChange = index => e => {
        this.props.designProfileStore.setTestimonialName(index, e.target.value);
        if (e.target.value) {
            this.props.designProfileStore.setError("testimonials[" + index + "].name", undefined);
        } else {
            this.props.designProfileStore.setError("testimonials[" + index + "].name", "The Name field is required.");
        }
    };

    handleChangeProfilePicture = (files, rejectedFiles) => {
       
        if (rejectedFiles && rejectedFiles.length > 0) {
            this.props.templateStore.openSnackbar("Profile image couldn't be uploaded. Please check size and format.");
        } else {
          
            if (this.props.templateStore.getType(this.props.type) === ProfileType.Venue.ordinal){
                this.props.designProfileStore.setProfilePictureVenue(this.props.profileId, files).then(message => {
                    console.log("Message: ", message);
                    if (message === "error") {
                        this.props.templateStore.openSnackbar("Profile image couldn't be uploaded. Please check size and format.");
                    }
                });
            } else {
                this.props.designProfileStore.setProfilePicture(files).then(message => {
                    console.log("Message: ", message);
                    if (message === "error") {
                        this.props.templateStore.openSnackbar("Profile image couldn't be uploaded. Please check size and format.");
                    }
                });
            }
           
        }
    };

    handleAddBackgroundImage = (files, rejectedFiles) => {
        if (rejectedFiles && rejectedFiles.length > 0) {
            let message = "";
            rejectedFiles.forEach(file => {
                message += file.name + ", ";
            });
            message = message.substr(0, message.length - 2);
            message += " couldn't be uploaded. Please check size and format.";
            this.props.templateStore.openSnackbar(message);
        }

        this.props.designProfileStore.setBackgroundImage(files).then(failedUploads => {
            /*if (failedUploads && failedUploads.length > 0) {
                let message = failedUploads.join(", ") + " couldn't be uploaded. Please check size and format.";
                this.props.templateStore.openSnackbar(message);
            }*/
        });
    };

    onConfirmRemoveImage = buttonIndex => {
        if (buttonIndex === 1) {
            this.props.designProfileStore.removeProfilePicture();
        }
    };

    handleDeleteProfilePicture = e => {
        if (IS_MOBILE) {
            navigator.notification.confirm(
                "Are you sure you want to remove the profile picture?", // message
                this.onConfirmRemoveImage, // callback to invoke with index of button pressed
                "Confirmation", // title
                ["Remove", "Do not remove"] // buttonLabels
            );
        } else if (window.confirm("Are you sure you want to remove the profile picture?")) {
            this.props.designProfileStore.removeProfilePicture();
        }
    };

    handleShowPlayedWithChange = e => {
        this.props.designProfileStore.setShowPlayedWith(e.target.checked);
    };

    handleShowAvatarChange = e => {
        this.props.designProfileStore.setShowAvatar(e.target.checked);
    };

    handleDeleteBackgroundPicture = image => {
        this.props.designProfileStore.removeBackgroundPicture(image);
    };

    handleBack = () => {
        if (this.props.type === "venue") {
            const { profile } = this.props.profileStore;
            this.props.history.push(`/venues/${profile.id}/edit/details`);
        }

        const { editProfileActiveStep } = this.props.templateStore;
        if (this.props.type === "act") {
            this.props.history.replace(`/myact/edit/${this.props.match.params.id}/details`);
        }
        this.props.templateStore.setEditProfileActiveStep(editProfileActiveStep - 1);
    };

    handleSubmitForm = e => {
        e.preventDefault();
        // submit
        const {
            backgroundImages,
            testimonials
        } = this.props.designProfileStore;
        this.setState({
            loadingVanityUrlTest: false,
            vanityUrlAvailable: false
        });
        
        this.setState({isSubmitted:true  });
        var testimonialError = false
        testimonials.forEach(testimonial => {
            if(testimonial.content.length > 1000){
                testimonialError = true
            }
        });
        if(testimonialError){
            this.setState({ isLoading: false });
            this.props.templateStore.openSnackbar("Your testimonal(s) are over the 1000 character limit. Please edit and try saving again.");
            return
        }
        if(this.state.errorMusic || this.state.errorVideo ) {
            this.setState({ isLoading: false });
            return
        }
        if((this.props.type === "act" || this.props.type === "venue") && backgroundImages.length === 0){
            window.scrollTo(0, 0)
            this.setState({ isLoading: false });
            return
        }
        this.setState({ isLoading: true  });
        this.props.designProfileStore.submit().then(resp => {
            if (this.props.type === "venue") {
                this.props.history.push(`/venues/${resp.id}/edit/financial`);
            }
            if (this.props.type === "act") {
                this.props.history.push(`/myact/edit/${resp.id}/social`);
            }
            if (this.props.type !== "act" && this.props.type !== "venue") {
                const { editProfileActiveStep } = this.props.templateStore;
                this.props.templateStore.setEditProfileActiveStep(editProfileActiveStep + 1);
            }
        }).catch(err => {
            if (err.validationError) {
                this.props.templateStore.openSnackbar("Please fix the invalid URLs before saving.");
            } else {
                const errors = err.response && err.response.data && err.response.data.errors;
                if (errors) {
                    const messages = Object.values(errors).join(", ");
                    this.props.templateStore.openSnackbar(messages);
                } else {
                    this.props.templateStore.openSnackbar("An error occurred while saving. Please check your inputs and try again.");
                }
            }
        }).finally(() => {
            this.setState({ isLoading: false });
        });
    };

    anyError(field) {
        if (!this.props.designProfileStore.errors) return false;
        if (!this.props.designProfileStore.errors[field]) return false;
        return true;
    }

    anyErrors() {
        
        const { errors,testimonials } = this.props.designProfileStore;

        const isEmptyTestimonial = testimonials?testimonials.some(testimonial => testimonial.name == "" || testimonial.content ==""):false;
        if(isEmptyTestimonial){
            return isEmptyTestimonial
        }

        if (!errors) {
            return false;
        }
        let keys = Object.keys(errors);

        for (let i = 0; i < keys.length; i++) {
            if (errors[keys[i]]) {
                return true;
            }
        }
        return false;
    }

    handleWebSiteChange = e => this.props.designProfileStore.setWebSite(e.target.value);
    handleValidateWebSite = e => this.props.designProfileStore.validateWebSite(e.target.value);

    handleFacebookChange = e => this.props.designProfileStore.setFacebook(e.target.value);
    handleValidateFacebook = e => this.props.designProfileStore.validateFacebook(e.target.value);

    handleTwitterChange = e => this.props.designProfileStore.setTwitter(e.target.value);
    handleValidateTwitter = e => this.props.designProfileStore.validateTwitter(e.target.value);

    handleBandcampChange = e => this.props.designProfileStore.setBandcamp(e.target.value);
    handleValidateBandcamp = e => this.props.designProfileStore.validateBandcamp(e.target.value);

    handleSoundcloudChange = e => this.props.designProfileStore.setSoundcloud(e.target.value);
    handleValidateSoundcloud = e => this.props.designProfileStore.validateSoundcloud(e.target.value);

    handleMixcloudChange = e => this.props.designProfileStore.setMixcloud(e.target.value);
    handleValidateMixcloud = e => this.props.designProfileStore.validateMixcloud(e.target.value);

    handleYoutubeChange = e => this.props.designProfileStore.setYoutube(e.target.value);
    handleValidateYoutube = e => this.props.designProfileStore.validateYoutube(e.target.value);
    
    handleInstagramChange = e => this.props.designProfileStore.setInstagram(e.target.value);
    handleValidateInstagram = e => this.props.designProfileStore.validateInstagram(e.target.value);

    handleGooglePlusChange = e => this.props.designProfileStore.setGooglePlus(e.target.value);
    handleValidateGooglePlus = e => this.props.designProfileStore.validateGooglePlus(e.target.value);

    handleLinkedInChange = e => this.props.designProfileStore.setLinkedIn(e.target.value);
    handleValidateLinkedin = e => this.props.designProfileStore.validateLinkedin(e.target.value);

    handleITunesChange = e => this.props.designProfileStore.setITunes(e.target.value);
    handleValidateItunes = e => this.props.designProfileStore.validateItunes(e.target.value);

    handleSpotifyChange = e => this.props.designProfileStore.setSpotify(e.target.value);
    handleValidateSpotify = e => this.props.designProfileStore.validateSpotify(e.target.value);


    errorText(field) {
        if (!this.props.designProfileStore.errors) return null;
        if (!this.props.designProfileStore.errors[field]) return null;
        return this.props.designProfileStore.errors[field];
    }

    addTestimonial = () => {
        let testimonial = { content: "", name: "" };
        this.props.designProfileStore.addTestimonial(testimonial);
    };

    handleTestimonialDelete = index => () => {
        this.props.designProfileStore.removeTestimonial(index);
        this.props.designProfileStore.setError("testimonials[" + index + "].Content", undefined);
        this.props.designProfileStore.setError("testimonials[" + index + "].name", undefined);
    };

    renderTestimonials = () => {
        const { testimonials } = this.props.designProfileStore;
        const {classes} = this.props;

        let result = [];

        for (let i = 0; i < testimonials.length; i++) {
            result.push(
                <Grid key={i} item xs={12} md={6} lg={6} style={{ marginBottom: 10 }}>
                    <Card style={{ height: "100%" }}>
                        <CardHeader
                            classes={{ root: "edit-testimonial-card-header",  title: classes.title
                            }}
                            action={
                                <div className="edit-testimonial-action-wrapper">
                                    <Button size="small" onClick={this.handleTestimonialDelete(i)} className="edit-testimonial-card-header-action">
                                        <DeleteIcon style={{ color: "#fff" }} />
                                        <Typography variant="subheading">
                                            Delete
                                        </Typography>
                                    </Button>
                                </div>
                            }
                            title={"Testimonial #" + (i + 1)}
                        />
                        <CardContent classes={{ root: "edit-testimonial-card-content" }}>
                            <Grid container spacing={0}>
                                <Grid item xs={12}>
                                    <TextField
                                        id={`testimonial-${i}`}
                                        label="Testimonial Message"
                                        margin="dense"
                                        multiline
                                        rows={5}
                                        value={testimonials[i].content}
                                        onChange={this.handleTestimonialContentChange(i)}
                                        InputLabelProps={{ shrink: true }}
                                        fullWidth
                                        error={this.anyError(`testimonials[${i}].Content`)}
                                        helperText={this.errorText(`testimonials[${i}].Content`)}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Label style={testimonials[i].content.length > 1000 ? {backgroundColor:"red", fontSize:10} : {fontSize:10}}>{testimonials[i].content.length}/1000</Label>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        id={`name-${i}`}
                                        label="From"
                                        margin="dense"
                                        value={testimonials[i].name}
                                        onChange={this.handleTestimonialNameChange(i)}
                                        InputLabelProps={{ shrink: true }}
                                        fullWidth
                                        error={this.anyError(`testimonials[${i}].name`)}
                                        helperText={this.errorText(`testimonials[${i}].name`)}
                                    />
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
            );
        }

        return result;
    };

    getProfileImageHelpText = () => {
        const { isConsultant } = this.props.designProfileStore;
        const type = this.props.type;
        
        if (type === "musician") {
            return "Complete your public profile with images and media to ensure you stand out from the crowd. Your public profile will be viewed by anyone searching for a musician and is your way of standing out from the crowd.";
        } else if (type === "act") {
            return "Complete your act public profile with images and media to ensure you stand out from the crowd. The act public profile will be viewed by anyone searching for a band, will appear in the gig guide listing and is your way of standing out from the crowd.";
        } else if (type === "venue") {
            return "Your venue public profile will be viewed by people who are searching for venues or using the gig guide app to search for entertainment. Complete your venue public profile with your logo and images to ensure you stand out from the crowd.";
        } else if (type === "agent" && !isConsultant) {
            return "Complete your agent public profile with images and media to ensure you stand out from the crowd. Your agent public profile will be viewed by anyone searching for an agent.";
        } else if (type === "privateHire") {
            return "Upload your profile pic here. This will be shown to people you are interacting with on the platform";
        } else {
            return "Upload your profile image. Maximum size is 2MB. Full HD resolution for best fit. You have the option to hide your profile image from your public profile page.";
        }
    };

    getBackgroundImageHelpText = () => {
        const type = this.props.type;
        if (type === "act") {
            return "Upload up to 4 main profile images to display on your act profile page. The maximum size for each image is 2MB. For the best fit use an image 1920px X 1080px.";
        }
        return "Upload up to 4 main profile images to display on your profile page. The maximum size for each image is 2MB. For the best fit use an image 1920px X 1080px.";
    };

    renderImageSlot = (index) => {
        const { backgroundImages, backgroundImgInProgress, maxBackgroundImagesCount } = this.props.designProfileStore;
        const imageCount = backgroundImages ? backgroundImages.length : 0;
        const image = imageCount > index ? backgroundImages[index] : null;
        
        if (image) {
            return (
                <div className="main-profile-image-slot filled">
                    <img src={image.url} alt={image.name || image.fileName} />
                    <div className="image-name-overlay">
                        {image.name || image.fileName || `Image ${index + 1}`}
                    </div>
                    <IconButton
                        className="delete-btn"
                        onClick={this.handleDeleteBackgroundPicture.bind(this, image)}
                    >
                        <DeleteIcon />
                    </IconButton>
                    {backgroundImgInProgress && !image.id && (
                        <LinearProgress className="background-image-linear-progress" />
                    )}
                </div>
            );
        }
        
        // Only show empty dropzone if we haven't reached the max
        if (imageCount >= maxBackgroundImagesCount) {
            return null;
        }
        
        // Only show one empty dropzone slot after the last uploaded image
        if (index > imageCount) {
            return (
                <div className="main-profile-image-slot placeholder">
                    <div className="upload-placeholder disabled">
                        <p>{index + 1}</p>
                    </div>
                </div>
            );
        }
        
        return (
            <Dropzone
                accept={ACCEPTED_FILE}
                maxSize={FILE_MAXSIZE}
                onDrop={this.handleAddBackgroundImage.bind(this)}
                multiple={false}
                className="main-profile-image-slot empty"
            >
                <div className="upload-placeholder">
                    <AddIcon />
                    <p>Upload Image</p>
                </div>
            </Dropzone>
        );
    };

    // Video helper methods
    detectVideoProvider = (url) => {
        if (!url) return null;
        if (youtubeReg.test(url)) return "youtube";
        if (vimeoReg.test(url)) return "vimeo";
        if (facebookVideoReg.test(url)) return "facebook";
        if (tiktokReg.test(url)) return "tiktok";
        return null;
    };

    getVideoProviderLabel = (provider) => {
        switch (provider) {
            case "youtube": return "YouTube";
            case "vimeo": return "Vimeo";
            case "facebook": return "Facebook";
            case "tiktok": return "TikTok";
            default: return "Video";
        }
    };

    handleNewVideoUrlChange = (e) => {
        this.setState({ newVideoUrl: e.target.value, newVideoError: "" });
    };

    handleAddVideo = async () => {
        const { newVideoUrl, videoUrls } = this.state;
        const { maxVideoCount } = this.props.designProfileStore;
        
        if (!newVideoUrl.trim()) {
            this.setState({ newVideoError: "Please enter a video URL" });
            return;
        }

        if (!validation.urlValidation(newVideoUrl)) {
            this.setState({ newVideoError: "Please enter a valid URL" });
            return;
        }

        const provider = this.detectVideoProvider(newVideoUrl);
        if (!provider) {
            this.setState({ newVideoError: "Only YouTube, Vimeo, Facebook, and TikTok videos are supported" });
            return;
        }

        if (videoUrls.length >= maxVideoCount) {
            this.setState({ newVideoError: "Maximum 4 videos allowed" });
            return;
        }

        // Fetch video metadata (title and thumbnail) using oEmbed API
        let metadata = { title: "", thumbnail: "" };
        try {
            metadata = await this.fetchVideoMetadata(newVideoUrl, provider);
        } catch (e) {
            console.log("Could not fetch video metadata:", e);
        }

        const videoObj = {
            id: Date.now().toString(),
            url: newVideoUrl,
            provider: provider,
            title: metadata.title || "",
            thumbnail: metadata.thumbnail || ""
        };

        const newVideoUrls = [...videoUrls, videoObj];
        this.setState({ videoUrls: newVideoUrls, newVideoUrl: "", newVideoError: "" });
        // Sync to store
        this.props.designProfileStore.setVideoUrl(this.serializeVideoUrls(newVideoUrls));
    };

    fetchVideoMetadata = async (url, provider) => {
        let oembedUrl = "";
        
        if (provider === "youtube") {
            oembedUrl = `https://www.youtube.com/oembed?url=${encodeURIComponent(url)}&format=json`;
        } else if (provider === "vimeo") {
            oembedUrl = `https://vimeo.com/api/oembed.json?url=${encodeURIComponent(url)}`;
        } else {
            // Facebook and TikTok require API keys - return empty metadata
            return { title: "", thumbnail: "" };
        }

        try {
            const response = await fetch(oembedUrl);
            if (response.ok) {
                const data = await response.json();
                return {
                    title: data.title || "",
                    thumbnail: data.thumbnail_url || ""
                };
            }
        } catch (e) {
            console.log("oEmbed fetch failed:", e);
        }
        return { title: "", thumbnail: "" };
    };

    handleRemoveVideo = (index) => {
        const { videoUrls } = this.state;
        const newVideoUrls = [...videoUrls];
        newVideoUrls.splice(index, 1);
        this.setState({ videoUrls: newVideoUrls });
        // Sync to store
        this.props.designProfileStore.setVideoUrl(this.serializeVideoUrls(newVideoUrls));
    };

    getVideosHelpText = () => {
        const type = this.props.type;
        if (type === "agent") {
            return "Add up to 4 video links to showcase your agency and acts. Supported platforms: YouTube, Vimeo, Facebook, and TikTok. Make sure videos have embedding enabled.";
        }
        return "Add up to 4 videos to showcase your talents. Supported platforms: YouTube, Vimeo, Facebook, and TikTok. Make sure your videos have embedding enabled.";
    };

    getSoundsHelpText = () => {
        return "Embed your Spotify or SoundCloud music on your public profile. You can embed your full artist profile to show all your music, or embed a single track or playlist.";
    };

    handleMusicEmbedModeChange = (e) => {
        this.props.designProfileStore.setMusicEmbedMode(e.target.value);
    };

    getGalleryHelpText = () => {
        return "Add up to 4 high-resolution photos for your gallery. These will be displayed on your public profile and downloadable by hirers. Maximum 10MB per image. For best quality, use images at least 1920x1080 pixels.";
    };

    formatFileSize = (bytes) => {
        if (!bytes || bytes === 0) return "0 Bytes";
        const k = 1024;
        const sizes = ["Bytes", "KB", "MB", "GB"];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    };

    handleAddGalleryImage = async (acceptedFiles, rejectedFiles) => {
        if (rejectedFiles && rejectedFiles.length > 0) {
            this.props.templateStore.openSnackbar("Some files couldn't be uploaded. Please check size (max 10MB) and format.");
        }

        if (!acceptedFiles || acceptedFiles.length === 0) {
            return;
        }

        const { galleryImages, maxGalleryImagesCount } = this.props.designProfileStore;
        const {currentProfile} = this.props.profileStore;
        const profileId = this.props.profileId || currentProfile?.id;
        
        if (!profileId) {
            this.props.templateStore.openSnackbar("Profile not loaded. Please try again.");
            return;
        }

        if (galleryImages.length >= maxGalleryImagesCount) {
            this.props.templateStore.openSnackbar(`Maximum ${maxGalleryImagesCount} gallery images allowed.`);
            return;
        }

        for (let file of acceptedFiles) {
            if (this.props.designProfileStore.galleryImages.length >= maxGalleryImagesCount) break;
            
            const tempId = uniqid();
            const previewUrl = URL.createObjectURL(file);
            const galleryImage = {
                id: tempId,
                url: previewUrl,
                fileUrl: previewUrl,
                fileName: file.name,
                title: "",
                fileType: file.type,
                fileSize: file.size,
                file: file,
                isUploading: true,
                uploadStatus: 'uploading'
            };
            
            this.props.designProfileStore.addGalleryImage(galleryImage);
            this.uploadGalleryImage(file, tempId, profileId);
        }
    };

    uploadGalleryImage = async (file, tempId, profileId) => {
        try {
            this.props.designProfileStore.setGalleryUploadProgress(tempId, 10);

            const fileExtension = file.name.split('.').pop();
            const ticks = (((new Date()).getTime() * 10000) + 621355968000000000);
            const uniqueName = `${ticks}.${fileExtension}`;
            const storageKey = `gallery/${profileId}/${uniqueName}`;

            this.props.designProfileStore.setGalleryUploadProgress(tempId, 30);

            const result = await Storage.put(storageKey, file, {
                contentType: file.type
            });

            this.props.designProfileStore.setGalleryUploadProgress(tempId, 70);

            const confirmResponse = await agent.GalleryImages.confirmUpload(profileId, {
                storageKey: result.key,
                fileName: file.name,
                fileType: file.type,
                fileSize: file.size,
                title: ""
            });

            this.props.designProfileStore.setGalleryUploadProgress(tempId, 100);

            const savedImage = confirmResponse.image;
            this.props.designProfileStore.replaceGalleryImage(tempId, {
                id: savedImage.id,
                url: savedImage.fileUrl || savedImage.url,
                fileUrl: savedImage.fileUrl || savedImage.url,
                fileName: savedImage.fileName,
                title: savedImage.title || "",
                fileType: savedImage.fileType,
                fileSize: savedImage.fileSize,
                uploadedAt: savedImage.uploadedAt,
                isUploading: false,
                uploadStatus: 'uploaded'
            });

        } catch (error) {
            console.error("Gallery upload failed:", error);
            let errorMessage = "Image upload failed. Please try again.";
            if (error?.response?.data?.message) {
                errorMessage = error.response.data.message;
            } else if (error?.message) {
                errorMessage = error.message;
            }
            this.props.templateStore.openSnackbar(errorMessage);
            this.props.designProfileStore.removeGalleryImageById(tempId);
        }
    };

    handleDeleteGalleryImage = async (imageId) => {
        const {currentProfile} = this.props.profileStore;
        const profileId = this.props.profileId || currentProfile?.id;
        const { galleryImages } = this.props.designProfileStore;
        const image = galleryImages.find(img => img.id === imageId);

        if (image?.isUploading) {
            this.props.designProfileStore.removeGalleryImageById(imageId);
            return;
        }

        this.setState(prev => ({
            galleryDeletingIds: [...prev.galleryDeletingIds, imageId]
        }));

        try {
            if (profileId && typeof imageId === 'number') {
                await agent.GalleryImages.delete(profileId, imageId);
            }
            setTimeout(() => {
                this.props.designProfileStore.removeGalleryImageById(imageId);
                this.setState(prev => ({
                    galleryDeletingIds: prev.galleryDeletingIds.filter(id => id !== imageId)
                }));
                this.props.templateStore.openSnackbar("Gallery image deleted.");
            }, 300);
        } catch (error) {
            console.error("Delete failed:", error);
            this.setState(prev => ({
                galleryDeletingIds: prev.galleryDeletingIds.filter(id => id !== imageId)
            }));
            const errorMessage = error?.response?.data?.message || "Failed to delete image.";
            this.props.templateStore.openSnackbar(errorMessage);
        }
    };

    handleGalleryTitleChange = (imageId, title) => {
        this.props.designProfileStore.updateGalleryImageTitle(imageId, title);
    };

    handleGalleryTitleBlur = async (imageId) => {
        const {currentProfile} = this.props.profileStore;
        const profileId = this.props.profileId || currentProfile?.id;
        if (!profileId || typeof imageId !== 'number') return;

        const { galleryImages } = this.props.designProfileStore;
        const image = galleryImages?.find(img => img.id === imageId);
        if (!image || image.isUploading) return;

        try {
            await agent.GalleryImages.updateTitle(profileId, imageId, {
                title: image.title || ""
            });
            this.setState(prev => ({
                gallerySavedTitles: { ...prev.gallerySavedTitles, [imageId]: true }
            }));
            setTimeout(() => {
                this.setState(prev => {
                    const updated = { ...prev.gallerySavedTitles };
                    delete updated[imageId];
                    return { gallerySavedTitles: updated };
                });
            }, 2000);
        } catch (error) {
            console.error("Failed to update title:", error);
            this.props.templateStore.openSnackbar("Failed to save title.");
        }
    };

    handleGalleryView = (image) => {
        this.setState({
            galleryPreviewOpen: true,
            galleryPreviewImage: image
        });
    };

    handleCloseGalleryPreview = () => {
        this.setState({
            galleryPreviewOpen: false,
            galleryPreviewImage: null
        });
    };

    handleGalleryDownload = (image) => {
        try {
            if (image.fileUrl || image.url) {
                window.open(image.fileUrl || image.url, '_blank');
            } else if (image.file) {
                const url = URL.createObjectURL(image.file);
                window.open(url, '_blank');
            }
        } catch (error) {
            console.error("Download failed:", error);
            this.props.templateStore.openSnackbar("Download failed. Please try again.");
        }
    };

    renderGalleryItem = (image) => {
        const { galleryUploadProgress } = this.props.designProfileStore;
        const { gallerySavedTitles, galleryDeletingIds } = this.state;
        const isUploading = image.isUploading || image.uploadStatus === 'uploading';
        const hasError = image.uploadStatus === 'error';
        const isDeleting = galleryDeletingIds.includes(image.id);
        const isSaved = gallerySavedTitles[image.id];

        return (
            <div key={image.id} className={`gallery-attachment-item ${isUploading ? "uploading" : ""} ${hasError ? "error" : ""} ${isDeleting ? "deleting" : ""}`}>
                <div className="gallery-thumbnail-wrapper" onClick={() => !isUploading && this.handleGalleryView(image)}>
                    <img 
                        src={image.url || image.fileUrl} 
                        alt={image.title || image.fileName}
                        className="gallery-attachment-thumbnail"
                    />
                    {isUploading && (
                        <div className="gallery-upload-overlay">
                            <CircularProgress size={40} style={{ color: '#fff' }} />
                        </div>
                    )}
                </div>
                
                <div className="gallery-attachment-details">
                    <div className="gallery-title-row">
                        <TextField
                            value={image.title || ""}
                            onChange={(e) => this.handleGalleryTitleChange(image.id, e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    this.handleGalleryTitleBlur(image.id);
                                }
                            }}
                            placeholder="Enter image title... (Press Enter to save)"
                            fullWidth
                            margin="none"
                            className="gallery-title-input"
                            disabled={isUploading}
                        />
                        {isSaved && (
                            <span className="gallery-saved-indicator">
                                <CheckCircleIcon /> Saved
                            </span>
                        )}
                    </div>
                    <div className="gallery-attachment-meta">
                        <span className="gallery-filename">{image.fileName}</span>
                        {image.fileSize && (
                            <>
                                <span>•</span>
                                <span>{this.formatFileSize(image.fileSize)}</span>
                            </>
                        )}
                        {isUploading && (
                            <>
                                <span>•</span>
                                <span>Uploading...</span>
                            </>
                        )}
                    </div>
                    {isUploading && (
                        <div className="gallery-progress-bar">
                            <div 
                                className="gallery-progress" 
                                style={{ width: `${galleryUploadProgress[image.id] || 0}%` }}
                            />
                        </div>
                    )}
                </div>
                
                <div className="gallery-attachment-actions">
                    {!isUploading && !hasError && (
                        <>
                            <IconButton 
                                className="gallery-action-btn view"
                                onClick={() => this.handleGalleryView(image)}
                                title="View Image"
                                size="small"
                            >
                                <VisibilityIcon />
                            </IconButton>
                            <IconButton 
                                className="gallery-action-btn download"
                                onClick={() => this.handleGalleryDownload(image)}
                                title="Download Image"
                                size="small"
                            >
                                <CloudDownloadIcon />
                            </IconButton>
                        </>
                    )}
                    <IconButton 
                        className="gallery-action-btn delete"
                        onClick={() => this.handleDeleteGalleryImage(image.id)}
                        title={isUploading ? "Cancel Upload" : "Delete Image"}
                        size="small"
                    >
                        {isUploading ? <CloseIcon /> : <DeleteIcon />}
                    </IconButton>
                </div>
            </div>
        );
    };

    renderGalleryDropzone = () => {
        const { galleryImages, maxGalleryImagesCount } = this.props.designProfileStore;
        const imageCount = galleryImages ? galleryImages.length : 0;

        if (imageCount >= maxGalleryImagesCount) {
            return null;
        }

        return (
            <Dropzone
                accept={ACCEPTED_FILE}
                maxSize={GALLERY_FILE_MAXSIZE}
                onDrop={this.handleAddGalleryImage}
                multiple={true}
                className="gallery-upload-dropzone"
            >
                <div className="gallery-upload-placeholder">
                    <AddIcon style={{ fontSize: 32 }} />
                    <Typography variant="body2">Drop images here or click to upload</Typography>
                    <Typography variant="caption" color="textSecondary">Max 10MB per image • JPEG, PNG</Typography>
                </div>
            </Dropzone>
        );
    };

    renderGalleryPreviewDialog = () => {
        const { galleryPreviewOpen, galleryPreviewImage } = this.state;

        return (
            <Dialog
                open={galleryPreviewOpen}
                onClose={this.handleCloseGalleryPreview}
                maxWidth="lg"
                fullWidth
                className="gallery-preview-dialog"
            >
                <DialogTitle>
                    {galleryPreviewImage?.title || galleryPreviewImage?.fileName || "Image Preview"}
                    <IconButton
                        onClick={this.handleCloseGalleryPreview}
                        style={{ position: 'absolute', right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    {galleryPreviewImage && (
                        <img 
                            src={galleryPreviewImage.fileUrl || galleryPreviewImage.url} 
                            alt={galleryPreviewImage.title || galleryPreviewImage.fileName}
                            style={{ width: '100%', height: 'auto', maxHeight: '70vh', objectFit: 'contain' }}
                        />
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleGalleryDownload(galleryPreviewImage)} color="primary">
                        <CloudDownloadIcon style={{ marginRight: 8 }} /> Download
                    </Button>
                    <Button onClick={this.handleCloseGalleryPreview}>Close</Button>
                </DialogActions>
            </Dialog>
        );
    };

    renderVideoSlot = (video, index) => {
        const providerLabel = this.getVideoProviderLabel(video.provider);
        const displayTitle = video.title || video.url.substring(0, 50) + "...";
        const hasThumbnail = video.thumbnail && video.thumbnail.length > 0;
        
        return (
            <div className={`video-slot filled ${hasThumbnail ? 'with-thumbnail' : ''}`} key={video.id || index}>
                {hasThumbnail ? (
                    <img 
                        src={video.thumbnail} 
                        alt={video.title || "Video thumbnail"} 
                        className="video-thumbnail"
                    />
                ) : null}
                <div className="video-overlay">
                    <div className="video-provider-badge">{providerLabel}</div>
                    <div className="video-title-preview">{displayTitle}</div>
                </div>
                <IconButton
                    className="delete-btn"
                    onClick={() => this.handleRemoveVideo(index)}
                >
                    <DeleteIcon />
                </IconButton>
            </div>
        );
    };

    getLinksHelpText = () => {
        const type = this.props.type;
        const baseText = type === "act"
            ? "Let people find your act all over the web! These social icons will appear on your public profile so that people can find you on the interwebs."
            : "Let people find you all over the web! These social icons will appear on your public profile so that people can find you on the interwebs.";
        return baseText + " Tip: You need to enter a fully formed URL, example: http://www.yourwebsite.com.";
    };

    getMediaHelpText = () => {
        const type = this.props.type;
        if (type === "agent") {
            return "This media link will showcase your agency and acts on your public profile page. Be sure to use your best Youtube or Vimeo clip. Make sure that your video has embedding enabled.";
        }
        return "Add video and audio to your profile to showcase your talents. For video, you can add a Youtube or Vimeo video. Make sure that your video has embedding enabled. For audio, you can add a single Spotify or Soundcloud link, or embed a playlist.";
    };

    getTestimonialsHelpText = () => {
        const type = this.props.type;
        if (type === "venue") {
            return "Use this section to add testimonials about your venue. (1000 character limit)";
        } else if (type === "agent") {
            return "Use this section to add testimonials from your venues, acts and corporate clients. (1000 character limit)";
        } else if (type === "act") {
            return "Use this section to add testimonials about your act performances.";
        }
        return "Use this section to add testimonials about your performances. (1000 character limit)";
    };

    render() {
        const {
            videoUrl,
            musicUrl,
            musicEmbedMode,
            galleryImages,
            maxVideoCount,
            maxGalleryImagesCount,
            profileImage,
            backgroundImages,
            profileImgInProgress,
            backgroundImgInProgress,
            showPlayedWith,
            showAvatar,
            maxBackgroundImagesCount,
            vanityUrl,
            isConsultant,
            webSite,
            facebook,
            twitter,
            bandcamp,
            soundcloud,
            mixcloud,
            youtube,
            instagram,
            googlePlus,
            linkedIn,
            iTunes,
            spotify
        } = this.props.designProfileStore;
        const { editProfileActiveStep } = this.props.templateStore;
        const type = this.props.type;
        const steps = this.props.templateStore.getSteps(type);
        const { isLoading, isSubmitted, videoUrls } = this.state;
        return (
            <div className="Profile-General">
                <form onSubmit={this.handleSubmitForm} className="form-relative">
                    <Loading showed={isLoading} />
                    <Grid container spacing={24}>
                        <Grid item xs={12} lg={12}>
                            <SectionHeader
                                title="Profile Image"
                                helpText={this.getProfileImageHelpText()}
                            />
                            <Grid container spacing={8}>
                                <Grid item xs={12}>
                                    <Grid container spacing={0}>
                                        <Grid item xs={12}>
                                            <div className="profile-pic">
                                                {!profileImage && (
                                                    <div>
                                                        <Dropzone
                                                            accept={ACCEPTED_FILE}
                                                            maxSize={FILE_MAXSIZE}
                                                            onDrop={this.handleChangeProfilePicture.bind(this)}
                                                            multiple={false}
                                                            className="dropzone"
                                                        >
                                                            <p>Select file.</p>
                                                        </Dropzone>
                                                    </div>
                                                )}
                                                {profileImage && (
                                                    <div className="profile-pic-container">
                                                        {profileImgInProgress ? (
                                                            <Avatar alt="Avatar" className="avatar">
                                                                processing
                                                                <CircularProgress size={240} className="prof-pic-progress" thickness={1} />
                                                            </Avatar>
                                                        ) : (
                                                                <Avatar alt="Avatar" src={profileImage.url400} className="avatar" />
                                                            )}
                                                        <Button
                                                            variant="fab"
                                                            color="secondary"
                                                            className="del-avatar"
                                                            onClick={this.handleDeleteProfilePicture}
                                                        >
                                                            <DeleteIcon />
                                                        </Button>
                                                    </div>
                                                )}
                                            </div>
                                        </Grid>
                                         <Grid item xs={12} className="gridPublicToggle">
                                            <div style={{ marginleft: 20 }}>
                                                <Switch
                                                    checked={showAvatar}
                                                    onChange={this.handleShowAvatarChange}
                                                    value="showAvatar"
                                                    color="primary"
                                                    id="showInProfile"
                                                    className="showInProfile"
                                                />
                                                Show in my public profile page
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        {(type !== "staff" && type !== "privateHire") && (
                                <Fragment>
                                    <Grid item xs={12} lg={12}>
                                        <SectionHeader
                                            title="Main Profile Images"
                                            helpText={this.getBackgroundImageHelpText()}
                                        />
                                        <Grid container spacing={16} className="main-profile-images-grid">
                                            <Grid item xs={6} sm={3}>
                                                {this.renderImageSlot(0)}
                                            </Grid>
                                            <Grid item xs={6} sm={3}>
                                                {this.renderImageSlot(1)}
                                            </Grid>
                                            <Grid item xs={6} sm={3}>
                                                {this.renderImageSlot(2)}
                                            </Grid>
                                            <Grid item xs={6} sm={3}>
                                                {this.renderImageSlot(3)}
                                            </Grid>
                                        </Grid>
                                        {this.props.type === "act" && isSubmitted && (!backgroundImages || backgroundImages.length === 0) &&
                                            <Grid item xs={12} className="gridPublicToggle" style={{ marginTop: 10 }}>
                                                <div style={{ color: 'red' }}>
                                                    You must add at least one image of your act. Make it a good one as this will be used in the Hot Giggity Live gig guide app as well as in venue marketing.
                                                </div>
                                            </Grid>
                                        }
                                        {this.props.type === "venue" && isSubmitted && (!backgroundImages || backgroundImages.length === 0) &&
                                            <Grid item xs={12} className="gridPublicToggle" style={{ marginTop: 10 }}>
                                                <div style={{ color: 'red' }}>
                                                    You must add at least one image of your venue. Make it a good one as this will be used in the Hot Giggity Live gig guide app.
                                                </div>
                                            </Grid>
                                        }
                                    </Grid>
                                </Fragment>
                            )}
                        {type !== "staff" && type != "privateHire" &&
                            !isConsultant && (
                                <Fragment>
                                    <Grid item xs={12} lg={12}>
                                        <SectionHeader
                                            title="Profile URL"
                                            helpText="Your Profile URL is the address on the web that allows people to find your Hot Giggity profile."
                                        />
                                        <Grid container spacing={8}>
                                            <Grid item xs={12}>
                                                <FormControl fullWidth margin="normal">
                                                    <Tooltip title="Unique Profile URL" placement="right">
                                                        <InputLabel shrink>
                                                            Profile URL (<i className="fa fa-sm fa-question">&nbsp;</i>)
                                                        </InputLabel>
                                                    </Tooltip>
                                                    <TextField
                                                        id="vanityUrl"
                                                        margin="normal"
                                                        placeholder="Input Profile URL"
                                                        fullWidth
                                                        value={vanityUrl === "undefined" ? "" : vanityUrl}
                                                        onChange={this.handleVanityUrlChange}
                                                        error={this.anyError("vanityUrl")}
                                                        helperText={this.errorText("vanityUrl")}
                                                        onKeyDown={e => {
                                                            if (e.keyCode === 32) {
                                                                return false;
                                                            }
                                                        }}
                                                        InputProps={{
                                                            startAdornment: <InputAdornment position="start">{BASE_URL}</InputAdornment>,
                                                            endAdornment: this.state.loadingVanityUrlTest ? (
                                                                <InputAdornment position="start">
                                                                    <CircularProgress size={20} />
                                                                </InputAdornment>
                                                            ) : this.state.vanityUrlAvailable ? (
                                                                <InputAdornment position="start">
                                                                    <DoneIcon />
                                                                </InputAdornment>
                                                            ) : (
                                                                        ""
                                                                    )
                                                        }}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Fragment>
                            )}

                        {type !== "staff" && type != "privateHire" &&
                                                    !isConsultant && 
                        (
                            <Fragment>
                            <Grid item xs={12} lg={12}>
                                <SectionHeader
                                    title="Links"
                                    helpText={this.getLinksHelpText()}
                                />
                                <Grid container spacing={8}>
                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            id="webSite"
                                            label="Website"
                                            margin="dense"
                                            fullWidth
                                            value={webSite}
                                            onChange={this.handleWebSiteChange}
                                            onBlur={this.handleValidateWebSite}
                                            error={this.anyError("webSite")}
                                            helperText={this.errorText("webSite")}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            id="facebook"
                                            label="Facebook"
                                            margin="dense"
                                            fullWidth
                                            value={facebook}
                                            onChange={this.handleFacebookChange}
                                            onBlur={this.handleValidateFacebook}
                                            error={this.anyError("facebook")}
                                            helperText={this.errorText("facebook")}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            id="twitter"
                                            label="Twitter"
                                            margin="dense"
                                            fullWidth
                                            value={twitter}
                                            onChange={this.handleTwitterChange}
                                            onBlur={this.handleValidateTwitter}
                                            error={this.anyError("twitter")}
                                            helperText={this.errorText("twitter")}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            id="bandcamp"
                                            label="Bandcamp"
                                            margin="dense"
                                            fullWidth
                                            value={bandcamp}
                                            onChange={this.handleBandcampChange}
                                            onBlur={this.handleValidateBandcamp}
                                            error={this.anyError("bandcamp")}
                                            helperText={this.errorText("bandcamp")}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            id="soundcloud"
                                            label="Soundcloud"
                                            margin="dense"
                                            fullWidth
                                            value={soundcloud}
                                            onChange={this.handleSoundcloudChange}
                                            onBlur={this.handleValidateSoundcloud}
                                            error={this.anyError("soundcloud")}
                                            helperText={this.errorText("soundcloud")}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            id="mixcloud"
                                            label="Mixcloud"
                                            margin="dense"
                                            fullWidth
                                            value={mixcloud}
                                            onChange={this.handleMixcloudChange}
                                            onBlur={this.handleValidateMixcloud}
                                            error={this.anyError("mixcloud")}
                                            helperText={this.errorText("mixcloud")}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            id="youtube"
                                            label="Youtube"
                                            margin="dense"
                                            fullWidth
                                            value={youtube}
                                            onChange={this.handleYoutubeChange}
                                            onBlur={this.handleValidateYoutube}
                                            error={this.anyError("youtube")}
                                            helperText={this.errorText("youtube")}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            id="instagram"
                                            label="Instagram"
                                            margin="dense"
                                            fullWidth
                                            value={instagram}
                                            onChange={this.handleInstagramChange}
                                            onBlur={this.handleValidateInstagram}
                                            error={this.anyError("instagram")}
                                            helperText={this.errorText("instagram")}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            id="googlePlus"
                                            label="Tiktok"
                                            margin="dense"
                                            fullWidth
                                            value={googlePlus}
                                            onChange={this.handleGooglePlusChange}
                                            onBlur={this.handleValidateGooglePlus}
                                            error={this.anyError("googlePlus")}
                                            helperText={this.errorText("googlePlus")}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            id="linkedIn"
                                            label="Linked In"
                                            margin="dense"
                                            fullWidth
                                            value={linkedIn}
                                            onChange={this.handleLinkedInChange}
                                            onBlur={this.handleValidateLinkedin}
                                            error={this.anyError("linkedIn")}
                                            helperText={this.errorText("linkedIn")}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            id="iTunes"
                                            label="Apple Music"
                                            margin="dense"
                                            fullWidth
                                            value={iTunes}
                                            onChange={this.handleITunesChange}
                                            onBlur={this.handleValidateItunes}
                                            error={this.anyError("iTunes")}
                                            helperText={this.errorText("iTunes")}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            id="spotify"
                                            label="Spotify"
                                            margin="dense"
                                            fullWidth
                                            value={spotify}
                                            onChange={this.handleSpotifyChange}
                                            onBlur={this.handleValidateSpotify}
                                            error={this.anyError("spotify")}
                                            helperText={this.errorText("spotify")}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Fragment>
                        )
                        }
                        {type !== "staff" &&
                            !isConsultant &&
                            type !== "venue" && type != "privateHire" && (
                                <Fragment>
                                    {/* VIDEOS SECTION */}
                                    <Grid item xs={12} lg={12}>
                                        <SectionHeader
                                            title={`Videos (${videoUrls ? videoUrls.length : 0}/${maxVideoCount})`}
                                            helpText={this.getVideosHelpText()}
                                        />
                                        <Grid container spacing={16} className="videos-grid">
                                            {videoUrls && videoUrls.length > 0 && videoUrls.map((video, index) => (
                                                <Grid item xs={6} sm={3} key={video.id || index}>
                                                    {this.renderVideoSlot(video, index)}
                                                </Grid>
                                            ))}
                                            {(!videoUrls || videoUrls.length < maxVideoCount) && (
                                                <Grid item xs={12}>
                                                    <div className="add-video-form">
                                                        <TextField
                                                            id="newVideoUrl"
                                                            label="Add Video URL"
                                                            placeholder="Paste YouTube, Vimeo, Facebook, or TikTok URL"
                                                            margin="dense"
                                                            fullWidth
                                                            value={this.state.newVideoUrl}
                                                            onChange={this.handleNewVideoUrlChange}
                                                            error={!!this.state.newVideoError}
                                                            helperText={this.state.newVideoError || "Supports YouTube, Vimeo, Facebook, and TikTok videos"}
                                                            InputProps={{
                                                                endAdornment: (
                                                                    <InputAdornment position="end">
                                                                        <Button
                                                                            variant="contained"
                                                                            color="primary"
                                                                            size="small"
                                                                            onClick={this.handleAddVideo}
                                                                        >
                                                                            Add
                                                                        </Button>
                                                                    </InputAdornment>
                                                                )
                                                            }}
                                                        />
                                                    </div>
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Grid>

                                    {/* SOUNDS SECTION */}
                                    {(type === "musician" || type === "act") && (
                                        <Grid item xs={12} lg={12}>
                                            <SectionHeader
                                                title="Sounds"
                                                helpText={this.getSoundsHelpText()}
                                            />
                                            <Grid container spacing={8}>
                                                <Grid item xs={12}>
                                                    <FormControl component="fieldset" style={{ marginBottom: 16 }}>
                                                        <Typography variant="body2" style={{ marginBottom: 8, color: '#666' }}>
                                                            What would you like to embed?
                                                        </Typography>
                                                        <RadioGroup
                                                            row
                                                            name="musicEmbedMode"
                                                            value={musicEmbedMode || "track"}
                                                            onChange={this.handleMusicEmbedModeChange}
                                                        >
                                                            <FormControlLabel
                                                                value="profile"
                                                                control={<Radio color="primary" />}
                                                                label="Your full Spotify/SoundCloud profile (shows all your music)"
                                                            />
                                                            <FormControlLabel
                                                                value="track"
                                                                control={<Radio color="primary" />}
                                                                label="A single track or playlist"
                                                            />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <TextField
                                                        id="musicUrl"
                                                        label="Spotify or SoundCloud URL"
                                                        placeholder={musicEmbedMode === "profile" 
                                                            ? "Paste your artist profile URL (e.g., https://open.spotify.com/artist/...)"
                                                            : "Paste a track or playlist URL"
                                                        }
                                                        margin="dense"
                                                        fullWidth
                                                        value={musicUrl}
                                                        onChange={this.handleMusicUrlChange}
                                                        onBlur={this.handleValidateMusicUrl}
                                                        error={this.state.errorMusic}
                                                        helperText={this.state.errorMusic || (musicEmbedMode === "profile" 
                                                            ? "Tip: Paste your Spotify artist page or SoundCloud profile URL"
                                                            : "Tip: Paste a song, album, or playlist URL from Spotify or SoundCloud"
                                                        )}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    )}

                                    {/* PHOTO GALLERY SECTION */}
                                    {(type === "musician" || type === "act") && (
                                        <Grid item xs={12} lg={12}>
                                            <SectionHeader
                                                title={`Hi-res Photo Gallery (${galleryImages ? galleryImages.length : 0}/${maxGalleryImagesCount})`}
                                                helpText={this.getGalleryHelpText()}
                                            />
                                            <Typography variant="body2" style={{ color: '#999', marginTop: -8, marginBottom: 12, fontSize: '0.85rem' }}>
                                                Upload up to 4 hi-res images (max 10MB each). Add titles and download anytime.
                                            </Typography>
                                            
                                            {this.renderGalleryDropzone()}
                                            
                                            <div className="gallery-attachments-list">
                                                {galleryImages && galleryImages.map(image => this.renderGalleryItem(image))}
                                            </div>
                                            
                                            {this.renderGalleryPreviewDialog()}
                                        </Grid>
                                    )}
                                </Fragment>
                            )}
                        {type === "venue" && (
                            <Fragment>
                                <Grid item xs={12} lg={12}>
                                    <SectionHeader
                                        title="Trading Hours"
                                        helpText="List your trading hours here."
                                    />
                                    <Grid container spacing={8}>
                                        <Grid item xs={12}>
                                            <InputLabel className="margin-bottom-10">Trading Hours</InputLabel>
                                            <TradingHourTable />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Fragment>
                        )}
                        {(type === "musician" || type === "act") && (
                            <Fragment>
                                <Grid item xs={12} lg={12}>
                                    <SectionHeader
                                        title="Played At"
                                        helpText="Use this section to add venues that you have performed at."
                                    />
                                    <Grid container spacing={8}>
                                        <Grid item xs={12}>
                                            <InputLabel className="margin-bottom-10">Played At</InputLabel>
                                            <PlayedAtTable />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Fragment>
                        )}
                        {type === "musician" && (
                            <Fragment>
                                <Grid item xs={12} lg={12}>
                                    <SectionHeader
                                        title="Played With"
                                        helpText="Use this section to add musicians or bands that you have played with. You can hide this section from your public profile."
                                    />
                                    <Grid container spacing={8}>
                                        <Grid item xs={12} style={{ marginTop: -10 }}>
                                            <Grid container spacing={0}>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center"
                                                    }}
                                                >
                                                    <InputLabel>Played With</InputLabel>
                                                    <div style={{ marginleft: 20 }}>
                                                        <Switch
                                                            id="showPlayedWith"
                                                            checked={showPlayedWith}
                                                            onChange={this.handleShowPlayedWithChange}
                                                            value="showPlayedWith"
                                                            color="primary"
                                                        />
                                                        Show in profile
                                                    </div>
                                                </Grid>
                                                <Grid item xs={12} style={{ marginTop: -5 }}>
                                                    <PlayedWithTable />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Fragment>
                        )}
                        {type !== "staff" &&
                            !isConsultant && type != "privateHire" && (
                                <Fragment>
                                    <Grid item xs={12} lg={12}>
                                        <SectionHeader
                                            title="Testimonials"
                                            helpText={this.getTestimonialsHelpText()}
                                        />
                                        <Grid container spacing={8}>
                                            <Grid item xs={12}>
                                                <Grid container spacing={8}>
                                                    <Grid item xs style={{ display: "flex", alignItems: "flex-end" }}>
                                                        <InputLabel>Testimonials</InputLabel>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Grid container spacing={8}>
                                                            {this.renderTestimonials()}
                                                            <Grid item xs={12} md={6} lg={6} style={{ marginBottom: 10 }}>
                                                                <Tooltip id="tooltip-bottom" title="Add testimonial" placement="bottom">
                                                                    <Card className="add-testimonial-card" onClick={this.addTestimonial}>
                                                                        <AddIcon />
                                                                        <Typography color="primary" variant="headline" style={{ paddingTop: 3 }}>
                                                                            Add Testimonial
                                                                        </Typography>
                                                                    </Card>
                                                                </Tooltip>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Fragment>
                            )}
                        <Grid item xs={12} lg={12}>
                            <Grid container spacing={8}>
                                <Grid item xs={12} className="action">
                                    <Button disabled={editProfileActiveStep === 0} onClick={this.handleBack}>
                                        Back
                                    </Button>
                                    <Button
                                        id="submit-design"
                                        variant="contained"
                                        color="primary"
                                        type="submit"
                                        disabled={this.anyErrors() || this.state.loadingVanityUrlTest}
                                    >
                                        {editProfileActiveStep === steps.length - 1 ? "Finish" : "Save/Next"}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </form>
            </div>
        );
    }
}

export default withStyles(styles)(Design);
